/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Exhaustairhumiditydefect3Inputs */



/**
* | output |
* | --- |
* | "Exhaust air humidity sensor fault" |
*
* @param {Ahu_History_Key_Exhaustairhumiditydefect3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_exhaustairhumiditydefect3 = /** @type {((inputs?: Ahu_History_Key_Exhaustairhumiditydefect3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Exhaustairhumiditydefect3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Exhaust air humidity sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde hygrométrie air rejeté")
});
export { ahu_history_key_exhaustairhumiditydefect3 as "ahu_history_key_exhaustAirHumidityDefect" }